<template>
  <div class="page">
    <div class="content">
      <div class="title">如何创建答题？</div>
      <div class="first">
        <p class="way-title">
          <img
            src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220620/8d095cda4a2b673c1fc1290d1d96129c.svg"
            alt=""
          />用电脑创建
        </p>
        <p v-if="isMobile || !isInApp" class="mt20">使用浏览器进入立吉答题官方网站创建答题</p>
        <p @click="!isMobile && isInApp ? goWeb() : ''" >
          {{isInApp && !isMobile ?'点击进入立吉答题官网：' : '官网网址：'}}<span  :class="!isMobile && isInApp ? 'blue' : 'themeColor'">xiaoxiaodati.com</span>
        </p>
        <button
          class="copy-btn"
          v-clipboard:copy="copyText"
          v-clipboard:success="firstCopySuccess"
          v-clipboard:error="firstCopyError"
        >
          一键复制
        </button>
      </div>
      <p class="way-title">
        <img
          src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220620/bd3fabb40ddc8db2e45eb1f6bddb48cc.svg"
          alt=""
        />用手机创建
      </p>
      <div class="desc mt20">
        {{
          isMobile
            ? "点击下方按钮，进入小程序新建答题"
            : "微信扫描下方二维码，进入小程序"
        }}
      </div>
      <div class="finish" v-if="isMobile">
        <button class="btn" @click="toWx">前往创建答题</button>
      </div>
      <img v-else :src="src" alt="" />
      <div class="tips">完成创建后，点击【已完成创建】即可开始使用。</div>
      <div class="finish">
        <button class="btn" @click="finishCreate">已完成创建</button>
      </div>
    </div>
    <Contact />
    <van-popup v-model="show" @closed="close">
      <div class="login-img-modal">
        <img class="login-img" :src="src" alt="" />
        <p>
          {{
            bind_status == 1
              ? "微信扫描二维码，进入小程序创建答题"
              : "微信扫码登录后，才能同步已创建的答题活动呦"
          }}
        </p>
      </div>
    </van-popup>
  </div>
</template>
<script>
import Contact from "@/components/contact";
import { isMobile, verifyAuth, getWxUrl, requestAuth, getToken, reLogin, goWebWay } from "@/utils/common";
import { Toast } from "vant";
import api from "@/utils/api";
import questionOnly from "@/utils/questionOnly";
import { handleZI } from "../../utils/common";
let intervalAsk = null;
let checkTime = 0;

export default {
  components: { Contact },
  data() {
    return {
      url: "",
      isMobile: isMobile(),
      isInApp: wemeet.app.isTMWebview(),
      copyText: "http://xiaoxiaodati.com/",
      show: false,
      src:
        "https://cdn-xcx-qunsou.weiyoubot.cn/material/20211013/986befc70730defd7e2e5bd2272a393b.png",
      res: "",
      param: "",
      api,
      bind_status: 0
    };
  },
  methods: {
    goWeb() {
      goWebWay();
    },
    close() {
      this.show = false;
    },
    firstCopySuccess() {
      Toast("复制成功");
    },
    firstCopyError() {
      Toast("复制失败");
    },
    async toWx() {
      let url = this.url;
      let loginStatus = await verifyAuth();
      if (loginStatus) url = await getWxUrl();
      if (url) window.location.href = url;
    },
    async finishCreate() {
      let loginStatus = await verifyAuth();
      if (loginStatus && localStorage.getItem("bind_status") == 1) {
        this.$router.push({ name: "questionList" });
      } else {
        if (this.isMobile) {
          Toast("点击按钮，进入【立吉答题小程序】小程序创建答题");
        } else {
          this.show = true;
        }
      }
    },
    getAuthInfo() {
      let param = {
        access_token: getToken(),
        ref_url: window.location.href,
        code_type: 1, // 来源位置, 0:绑定页面, 1: 创建页面, 2: 选用模板 3: 绑定页面（new）4.选用模版（new）
        app_type: api.test ? 1 : 0,
        ...(isMobile() ? { source: 1 } : {}) // 0:电脑端, 1:手机端, 2:综合
      };
      questionOnly.get('/xcx/ques/v2/meeting/callback', param).then(res => {
        this.res = JSON.stringify(res);
        if (res.sta == 0) {
          if (!res.data.access_token) {
            this.url = res.data.url || "";
            this.src = res.data.qrcode || "";
            this.checkLoginSuccess(res.data.random_key, res.data.access_token);
          } else {
            this.handleLogin(res.data);
          }
        } else if (res.sta == -1 && res.errcode === 109 || res.sta == -500) {
          Toast("身份已过期请重新授权登录");
          setTimeout(() => {
            requestAuth(
              "https://" + api.hostName + ".xiaoxiaodati.com/createHelp"
            );
          }, 1000);
        } else {
          Toast(res.msg);
        }
      });
    },
    // 监听登录状态
    checkLoginSuccess(random_key, access_token) {
      if (intervalAsk) clearTimeout(intervalAsk);
      checkTime++;
      if (checkTime > 190 || this.$route.name != "createHelp") {
        checkTime = 0;
        intervalAsk = null;
        return;
      }
      let parm = {
        random_key,
        access_token,
        app_type: api.test ? 1 : 0,
        loadingMsg: 'no'
      };
      questionOnly.get(api.question.checkBindStatus, parm).then(async res => {
        if (res.sta === 0) {
          if (!res.data.status) {
            clearTimeout(intervalAsk);
            intervalAsk = setTimeout(() => {
              this.checkLoginSuccess(random_key, access_token);
            }, 3000);
          } else {
            this.handleLogin(res.data);
          }
        } else {
          clearTimeout(intervalAsk);
          intervalAsk = null;
          Toast(res.msg);
        }
      });
    },
    handleLogin(data) {
      if (!this.isMobile) {
        // pc更换二维码
        this.src =
          "https://cdn-xcx-qunsou.weiyoubot.cn/material/20211013/986befc70730defd7e2e5bd2272a393b.png";
      }
      if(localStorage.getItem('fail_count')) localStorage.removeItem('fail_count')
      Toast("登录成功");
      localStorage.setItem("token", data.access_token);
      localStorage.setItem("bind_status", 1);
      this.bind_status = 1;
      handleZI(data.mp_openid)
    },
    disableBrowserBack() {
      this.$router.push({ name: "intro" });
    }
  },
  async mounted() {
    let loginStatus = await verifyAuth();
    if(!loginStatus) return reLogin("", "/createHeip");
    if (
      wemeet.app.isTMWebview() && localStorage.getItem("bind_status") != 1) {
      this.getAuthInfo();
    }
    this.bind_status = localStorage.getItem("bind_status");
  },
  destroyed() {
    if (this.loginTip) localStorage.removeItem("loginTip");
  }
};
</script>

<style lang="scss" scoped>
@function rem($px) {
  @return $px / 75 + rem;
}
.page {
  padding: rem(20) rem(30);
  box-sizing: border-box;
  .content {
    background: #fff;
    padding: rem(30);
    border-radius: rem(8);
    font-size: rem(28);
    .title {
      font-weight: 700;
      font-size: rem(34);
      line-height: rem(51);
      text-align: center;
    }
    .desc {
      font-size: rem(28);
      line-height: rem(42);
    }
    .mt20 {
      margin-top: rem(20);
    }
    .finish {
      text-align: center;
      margin-top: rem(30);
      button {
        width: rem(325);
        height: rem(64);
        line-height: rem(64);
        text-align: center;
        background: #1890ff;
        color: #fff;
        font-size: rem(28);
        border-radius: rem(8);
        cursor: pointer;
      }
    }
    img {
      width: rem(350);
      height: rem(350);
      display: block;
      margin: 0 auto;
      margin-top: rem(30);
    }
  }
  .first {
    line-height: rem(42);
    margin: rem(40) 0;
  }
  .way-title {
    font-weight: 700;
    font-size: rem(28);
    display: flex;
    align-items: center;
    img {
      width: rem(36);
      height: rem(36);
      display: inline-block;
      margin: 0 rem(10) 0 0;
    }
  }
  .blue {
    color: #1890ff;
    cursor: pointer;
  }
  .tips {
    text-align: center;
    margin-top: rem(30);
    color: #999999;
  }
  .copy-btn {
    text-align: center;
    background: #1890ff;
    color: #fff;
    font-size: rem(28);
    border-radius: rem(8);
    line-height: rem(42);
    padding: rem(10) rem(30);
    margin-top: rem(10);
    cursor: pointer;
  }
  .login-img-modal {
    text-align: center;
    font-size: rem(22);
    padding: rem(30);
    p {
      margin-top: rem(30);
      color: #999999;
      line-height: rem(30);
    }
  }
  .login-img {
    width: rem(450);
    height: rem(450);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/create/createHelp.vue